export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.app': '应用中心',
  'menu.app.list': '应用管理',
  'menu.app.list.view': '应用信息',
  'menu.app.list.edit': '应用设置',
  'menu.app.list.add': '添加自定义应用',
  'menu.app.list.market': '应用市场',
  'menu.app.list.Details': '应用详情',
  'menu.app.list.Configuration': '应用配置',
  'menu.users.userApplyforRenewal': '判断是否PC.Mobile',
  'menu.personPortal': '个人门户页入口',
  'menu.app.abmapps': 'ABM 应用分发',
  'menu.app.entapps': '企业应用分发',
  'menu.setting.invitations': '分发用户邀请',
  'menu.setting.customize': '分发页面定制',
  'menu.app.createClassification': '应用分类管理',
  'menu.app.corpcert': '企业认证源',
  'menu.users': '用户中心',
  'menu.users.management': '用户管理',
  'menu.users.add': '添加用户',
  'menu.users.edit': '编辑用户',
  'menu.users.profile': '用户信息',
  'menu.users.linker': '通讯录集成',
  'menu.users.linker.add': '添加链接器',
  'menu.users.linker.edit': '编辑链接器',
  'menu.users.syncgene': '通讯录同步',
  'menu.users.syncgene.add': '添加链接器',
  'menu.users.syncgene.edit': '编辑链接器',
  'menu.users.userInfoLs': 'PC用户个人中心',
  'menu.users.userApplyfor': 'mob申请应用',
  'menu.users.userApplyforControl': 'mob门户页面',
  'menu.users.userApplyAdd': 'mob添加应用',
  'menu.users.userDetilsInfo': 'mob用户个人中心',
  'menu.users.expireUser': '将要到期数据列表',
  'menu.users.expireUserDetail': '将要到期数据详情',
  'menu.users.importResult': '用户导入结果',
  'menu.nofunc': '未购买',
  'menu.policy': '策略中心',
  'menu.policy.appPolicy': '应用策略',
  'menu.policy.appPolicy.editPolicy': '编辑策略',
  'menu.policy.deviceAdmitPolicy': '设备准入策略',
  'menu.policy.deviceAdmitPolicy.editPolicy': '编辑策略',
  'menu.devices': '设备中心',
  'menu.devices.list': '设备列表',
  'menu.permissions': '权限中心',
  'menu.permissions.users': '管理员账号',
  'menu.permissions.usersDetail': '管理员详情',
  'menu.permissions.roles': '管理员角色',
  'menu.deviceCenter': '设备中心',
  'menu.setting': '参数配置',
  'menu.setting.editEnt': '企业信息',
  'menu.setting.templates': '消息模板',
  'menu.setting.editSetting': '系统设置',
  'menu.setting.licencePage': '授权信息',
  'menu.log': '审计日志',
  'menu.log.loginLog': '用户行为日志',
  'menu.log.systemLog': '管理员操作日志',
  'menu.fileAudit': '文件审计',
  'menu.fileAudit.fileAuditLog': '文件审计',
  'menu.newsList': '消息中心',
  'menu.newsList.newsList': '推送历史',
  'menu.newsList.newsDetail': '消息详情',
  'menu.users.ladpService': 'LDAP服务',
  'menu.users.userTag': '用户标签',
  'menu.users.editTag': '用户静态标签信息',
  'menu.users.editTagDynamic': '用户动态标签信息',
  'menu.resetPassword': '密码重置',
  'menu.users.selfInfo': '个人信息',
  'menu.personPortal': '个人工作台',
  'menu.users.userApplyforRenewal': '用户续期申请',
};
